import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useRouter } from 'next/router'

import { getAccessToken } from 'redux-web/utils/session/actions'
import { getAppRoute } from 'helpers/application'

const WithAuth = WrapperComponent => {
  const Wrapper = props => {
    const router = useRouter()
    const { application, accessToken } = props
    const [authToken, setAuthToken] = useState()
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
      if (!accessToken) {
        if (getAccessToken()) {
          setAuthToken(getAccessToken())
          setIsLoading(false)
        } else {
          router.push(
            `${getAppRoute(application, 'url')}/signin?redirectTo=${
              router.asPath
            }`
          )
          setIsLoading(false)
        }
      } else {
        setAuthToken(accessToken)
        setIsLoading(false)
      }
    }, [])

    if (isLoading) return null

    return <WrapperComponent {...props} accessToken={authToken} />
  }

  Wrapper.propTypes = {
    accessToken: PropTypes.string,
    application: PropTypes.string,
  }

  if (WrapperComponent.getInitialProps) {
    Wrapper.getInitialProps = WrapperComponent.getInitialProps
  }

  return Wrapper
}

export default WithAuth
